import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustBadges } from './components/TrustBadges';
import { StatsStrip } from './components/StatsStrip';
import { Services } from './components/Services';
import { QuoteForm } from './components/QuoteForm';
import { WhyUs } from './components/WhyUs';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { LeadMagnet } from './components/LeadMagnet';
import { ServiceArea } from './components/ServiceArea';
import { FAQ } from './components/FAQ';
import { CtaBand } from './components/CtaBand';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { FloatingQuoteButton } from './components/FloatingQuoteButton';
export function App() {
  return <div className="min-h-screen flex flex-col w-full relative pb-14 lg:pb-0" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBadges data-id="element-4" />
        <StatsStrip data-id="element-5" />
        <Services data-id="element-6" />
        <QuoteForm data-id="element-7" />
        <WhyUs data-id="element-8" />
        <Process data-id="element-9" />
        <Testimonials data-id="element-10" />
        <LeadMagnet data-id="element-11" />
        <ServiceArea data-id="element-12" />
        <FAQ data-id="element-13" />
        <CtaBand data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <StickyMobileCTA data-id="element-16" />
      <FloatingQuoteButton data-id="element-17" />
    </div>;
}